import InfoNotificationAdmin from "../entities/InfoNotificationAdmin";
import PaginationNotification from "../entities/PaginationNotification";
import { NotificationRepository } from "../repositories/NotificationDataSourceRepository";

export class GetNotification {
	constructor(private repository: NotificationRepository) {}
	execute(params: GetNotificationParams): Promise<InfoNotificationAdmin[]> {
		return this.repository.getNotification(params.params);
	}
}

export class GetNotificationParams {
	constructor(public params: PaginationNotification) {}
}
